
import Vue from 'vue'
import { PropOptions } from 'vue/types/options'
import CardCollapse from '~/components/molecules/CardCollapse.vue'
import SexualityDetail from '~/components/molecules/SexualityDetail.vue'
import SexualityNote from '~/components/molecules/SexualityNote.vue'
import { GenderInfoList } from '~/types/api/result'

export default Vue.extend({
  components: {
    CardCollapse,
    SexualityDetail,
    SexualityNote,
  },
  props: {
    genderInfoList: {
      type: Object,
      required: true,
    } as PropOptions<GenderInfoList>,
  },
})
